import { message } from 'antd';
import { filterDeep } from 'deepdash-es/standalone';
import { put, select, takeLatest } from 'redux-saga/effects';
import { TemplatesAPI } from 'data/templates/api';
import { logger } from 'services';
import { getDynamicTemplatePreviewAction, updateDynamicTemplateConditionsAction } from '../actions';
import { denormalizePayload, setDynamicConditionInPayload, validatePhaseShiftInPayload } from '../api/transform';
import { updateDynamicConditions } from '../slices';
import { findLargestSumOfStartDayDuration, findLowestStartDay } from '../utils';
import { getActiveProjectTemplate } from './save';
function* updateDynamicTemplateConditionsSaga(action) {
    try {
        const { payload: { entityId, conditions } } = action;
        yield put(updateDynamicConditions({
            entityId,
            conditions
        }));
    } catch (error) {
        logger.error('an error on updating dynamic conditions', {
            error
        });
        message.error('There was an error on updating dynamic conditions');
    }
}
function* getDynamicTemplatePreviewSaga(action) {
    const { payload: { fields, compressTimeline, onSuccess, onFinally } } = action;
    const projectTemplate = yield select(getActiveProjectTemplate);
    try {
        const _template = setDynamicConditionInPayload(projectTemplate);
        const _phaseShiftValidTemplate = validatePhaseShiftInPayload(_template);
        const template = denormalizePayload(_phaseShiftValidTemplate);
        template.templateContent.projectPhases = filterDeep(template.templateContent.projectPhases, (object)=>{
            if (!object) {
                return false;
            }
            if (object.isNew) {
                return false;
            }
            delete object.isNew;
            return true;
        }, {
            childrenPath: [
                'tasks',
                'subTasks'
            ]
        }) || [];
        const largestDuration = findLargestSumOfStartDayDuration(template.templateContent.projectPhases);
        const lowestStartDay = findLowestStartDay(template.templateContent.projectPhases);
        const total = largestDuration - lowestStartDay;
        template.templateContent.duration = total;
        template.templateContent.startDay = lowestStartDay;
        const project = {
            fields: []
        };
        const validFieldValues = [
            0,
            false
        ];
        Object.keys(fields).forEach((fieldId)=>{
            const fieldValue = fields[fieldId];
            if (!fieldValue && !validFieldValues.includes(fieldValue)) {
                return;
            }
            if (Number.isNaN(parseInt(fieldId, 10))) {
                project[fieldId === 'arr' ? 'annualizedRecurringRevenue' : fieldId] = fieldValue;
            } else {
                var _fieldValue_value;
                var _project_fields;
                (_project_fields = project.fields) === null || _project_fields === void 0 ? void 0 : _project_fields.push({
                    fieldId,
                    fieldValue: Array.isArray(fieldValue) ? fieldValue.map((_field)=>{
                        var _field_value;
                        return (_field_value = _field.value) !== null && _field_value !== void 0 ? _field_value : _field;
                    }) : (_fieldValue_value = fieldValue.value) !== null && _fieldValue_value !== void 0 ? _fieldValue_value : fieldValue
                });
            }
        });
        const requestPayload = {
            templateRequest: {
                templateContent: template.templateContent,
                objectType: template.objectType,
                compressTimeline
            },
            project
        };
        const templatePreview = yield TemplatesAPI.preview(requestPayload);
        if (onSuccess) {
            onSuccess(templatePreview);
        }
    } catch (error) {
        logger.error('an error while generating preview for dynamic template', {
            error
        });
        message.error('There was an error while generating preview for dynamic template');
    } finally{
        if (onFinally) {
            onFinally();
        }
    }
}
export function* watchUpdateDynamicTemplateConditionsSaga() {
    yield takeLatest(updateDynamicTemplateConditionsAction.type, updateDynamicTemplateConditionsSaga);
}
export function* watchGetDynamicTemplatePreviewSaga() {
    yield takeLatest(getDynamicTemplatePreviewAction.type, getDynamicTemplatePreviewSaga);
}
